const DataProcedure = [
  {
    id: 1,
    stt: 1,
    name: 'Sản xuất tại xưởng',
    img: 'https://res.cloudinary.com/dcwu7dyzz/image/upload/v1775964577/s%E1%BA%A3n_xu%E1%BA%A5t_nh%C3%B4m_%C4%91%C3%BAc_t%E1%BA%A1i_x%C6%B0%E1%BB%9Fng_qll1hv.png'
  },
  {
    id: 2,
    stt: 2,
    name: 'Lắp đặt thi công',
    img: 'https://res.cloudinary.com/dcwu7dyzz/image/upload/v1775964576/l%E1%BA%AFp_%C4%91%E1%BA%B7t_thi_c%C3%B4ng_nh%C3%B4m_%C4%91%C3%BAc_ejsfn5.png'
  },
  {
    id: 3,
    stt: 3,
    name: 'Tân trang cổng cửa',
    img: 'https://res.cloudinary.com/dcwu7dyzz/image/upload/v1775964576/t%C3%A2n_trang_c%E1%BB%95ng_c%E1%BB%ADa_nh%C3%B4m_%C4%91%C3%BAc_jddhxr.png'
  },
  {
    id: 4,
    stt: 4,
    name: 'Khách hàng đánh giá',
    img: 'https://res.cloudinary.com/dcwu7dyzz/image/upload/v1775964577/kh%C3%A1ch_h%C3%A0ng_%C4%91%C3%A1nh_gi%C3%A1_nh%C3%B4m_%C4%91%C3%BAc_gf7sic.png'
  }
]

export default DataProcedure
